'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';
import { type UserProfile } from '@/lib/supabase/services';

interface ImpersonationContextType {
  impersonatedProfile: UserProfile | null;
  isImpersonating: boolean;
  startImpersonation: (profile: UserProfile) => void;
  stopImpersonation: () => void;
}

const ImpersonationContext = createContext<ImpersonationContextType>({
  impersonatedProfile: null,
  isImpersonating: false,
  startImpersonation: () => {},
  stopImpersonation: () => {},
});

export const useImpersonation = () => useContext(ImpersonationContext);

export const ImpersonationProvider = ({ children }: { children: React.ReactNode }) => {
  const [impersonatedProfile, setImpersonatedProfile] = useState<UserProfile | null>(null);

  const startImpersonation = useCallback((profile: UserProfile) => {
    setImpersonatedProfile(profile);
  }, []);

  const stopImpersonation = useCallback(() => {
    setImpersonatedProfile(null);
  }, []);

  return (
    <ImpersonationContext.Provider data-component-id="src/contexts/ImpersonationContext.tsx:34:4" data-component-path="src/contexts/ImpersonationContext.tsx" data-component-line="34" data-component-end-line="43" data-component-file="ImpersonationContext.tsx" data-component-name="ImpersonationContext.Provider" data-component-content="%7B%22elementName%22%3A%22ImpersonationContext.Provider%22%7D"
      value={{
        impersonatedProfile,
        isImpersonating: impersonatedProfile !== null,
        startImpersonation,
        stopImpersonation,
      }}
    >
      {children}
    </ImpersonationContext.Provider>
  );
};
